import {CrudCollection} from '@hc/graphql'
import toastr from 'toastr'
import {useUiStore} from "../../app";

export function useGridMenu(collection: CrudCollection) {
  const ui = useUiStore()
  return (vm) => {
    const menu = []
    //const selectedRows = vm.api.getSelectedNodes()
    let selectedRows = []
    vm.api.forEachNodeAfterFilter(node => {
      if(node.selected){
        selectedRows.push(node)
      }
    })
    const selectedObjects = selectedRows.map((r) => r.data)
    const selectedIds = selectedRows.map((r) => r.data.id)
    if(selectedRows.length > 0 && selectedRows.length <= 1) {
      const item = selectedRows[0].data
      menu.push({
        name: "View",
        action: () => {
          vm.$router.push(vm.crudRouter.view(item))
        },
      })
      menu.push({
        name: "View (New Window)",
        action: () => {
          window.open(vm.$router.resolve(vm.crudRouter.view(item)).href, '_blank')
        },
      })
      menu.push({
        name: "Edit",
        action: () => {
          vm.$router.push(vm.crudRouter.edit(item))
        },
      })
      if(collection.workflow){
        menu.push('separator')
        const object = selectedObjects[0]
        for(const action of collection.workflow.actions){
          //console.log("CHECK", action.isActive(object), vm.$auth.access[collection.name][action.name])
          if(!vm.$auth.access[collection.name][action.name]) continue
          if(!action.isActive(object)) continue
          const workflowItem = {
            name: action.title,
            action: async () => {
              let params = null
              let result = null
              //console.log("EXECUTE", action)
              if(action['options']['dialog']){
                //params = await new ModalDialog(action['options']['dialog'], action.title, object).async()
                const objectWithDefaultJoins = await collection.find(object.id, {includeDefaultJoins: true})
                const modalResult = await ui.openModal({
                  title: `${collection.titleSingular} - ${action.title}: ${collection.objectTitle(object)}`,
                  params: objectWithDefaultJoins || object,
                  component: action['options']['dialog'],
                  config: {
                    size: 'xl',
                    hideFooter: true,
                  }
                })
                if(!modalResult) return
                else params = modalResult
              } else {
                if(action['options']['confirmable'] == null || action['options']['confirmable'] == true){
                  const confirmExecute = await vm.$bvModal.msgBoxConfirm(`Are you sure to ${action.title.toLowerCase()} the ${collection.titleSingular} ${collection.objectTitle(item)}?`)
                  if(!confirmExecute) return
                }
              }
              if(params && Object.keys(params).length == 0) params = null
              try {
                vm.api.showLoadingOverlay()
                // execute action
                result = (await action.execute(object, params)).result
                if(result && result.objects_created){
                  const objects = await Promise.all(result.objects_created.map((id) => collection.find(id)))
                  vm.$emit('add', objects)
                }
                if (result && result.result && result.result.deleted_object_id === selectedObjects[0].id){
                  vm.$emit('delete', [selectedObjects[0]])
                }
                if (result && result.objects_deleted){
                  vm.$emit('delete', result.objects_deleted.map((id) => {return {id}}))
                }
                const updatedObject = await collection.find(object.id)
                //console.log("OBJECT", updatedObject)
                Object.assign(object, updatedObject)
                vm.api.refreshCells()
                if(action['options']['successDialog']){
                  ui.openModal({
                    title: action.title + ' Success',
                    params: {
                      result: result,
                      object: object,
                    },
                    component: action['options']['successDialog'],
                    config: {
                      size: 'xl',
                      okOnly: true,
                    }
                  })

                } else {
                  if(result.result){
                    vm.$toastr.info(result.result)
                  }
                }
              } catch(ex) {
                console.error("Action failure with error: %s", ex.message)
                vm.$bvModal.msgBoxOk(ex.message.toString().replace('GraphQL error:','').trim(), {
                  headerBgVariant: 'warning',
                  title: 'Workflow Error',
                })
              } finally {
                vm.api.hideOverlay()
              }
            },
          }
          menu.push(workflowItem)
        }
      }
      menu.push('separator')
    }
    if(selectedRows.length > 0 && !(collection.name === 'project' || collection.name === 'budget') && vm.$auth.access[collection.name].delete){
      menu.push({
        name: `Delete (${selectedRows.length})`,
        action: async () =>  {
          const result = await vm.$bvModal.msgBoxConfirm(`Are you sure to delete ${selectedIds.length} item(s)?`)
          if(!result) return
          try {
            vm.api.showLoadingOverlay()
            const deletedItems = await collection.delete(selectedIds, {skipJoins: true})
            vm.$emit('delete', deletedItems)
            if (deletedItems.length === selectedIds.length && deletedItems.length > 1) {
              toastr.info(
                'Successfully deleted ' + '(' + deletedItems.length + ') ' + collection.title,
                'Delete ' + collection.title
              )
            } else if (deletedItems.length === selectedIds.length && deletedItems.length === 1) {
              toastr.info(
                'Successfully deleted ' + deletedItems[0].name,
                'Delete ' + collection.titleSingular
              )
            }
            if(deletedItems.length == 0){
              vm.$bvModal.msgBoxOk('Error deleting ' + selectedIds.length + ' items!', {
                headerBgVariant: 'warning',
                title: 'Delete Error',
              })
            }
            else if(deletedItems.length < selectedIds.length){
              vm.$bvModal.msgBoxOk('Could only delete ' + deletedItems.length + ' of ' + selectedIds.length + ' items!', {
                headerBgVariant: 'warning',
                title: 'Delete Error',
              })
            }
          } catch(e) {
            vm.$bvModal.msgBoxOk(e.message.toString().replace('GraphQL error:','').trim(), {
              headerBgVariant: 'danger',
              title: 'Delete Error',
            })
          } finally {
            vm.api.hideOverlay()
          }
        },
      })
      menu.push('separator')
    }
    menu.push('export')

    if(vm.$auth.user.role == 'admin'){
      menu.push('chartRange')
    }

    menu.push('resetColumns')
    return menu

  }
}
